import { Component, ElementRef, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { CreationDocumentConflit } from 'src/app/utils/interfaces/new/CreationDocumentConflit';

enum CurrentStep {
  StepOne = 'stepOne',
  StepTwo = 'stepTwo'
}

export interface CreationDocumentConflictChoice {
  doOverwrite?: boolean;
  newFileName?: string;
}

@Component({
  selector: 'app-modal-conflict',
  templateUrl: './modal-conflict.component.html',
  styleUrls: [
    './modal-conflict.component.scss',
    '../../modal/modal.fragment.scss'
  ]
})
export class ModalConflictComponent implements OnInit {

  public documentConflict: CreationDocumentConflit;
  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;
  public printReferentHeader: boolean;
  public currentStep: CurrentStep = CurrentStep.StepOne;

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      newTitle: ['', Validators.required]
    });
  }

  public renameFile(): void {
    this.currentStep = CurrentStep.StepTwo;
  }

  public overwriteFile(): void {
    this.closeModal({
      doOverwrite: true
    });
  }

  public validNewTitle(): void {
    this.closeModal({
      doOverwrite: false,
      newFileName: this.formGroup.get('newTitle').value
    });
  }

  public formatDate(date: Date): string {
    return moment(date).format('DD/MM/YYYY à HH:mm');
  }

  public closeModal(choice: CreationDocumentConflictChoice): void {
    this.closeEmitter.emit(choice);
  }


}
